import type { RoundEpisodeRow } from "../round-episodes";
import type { WatchMatchup, WatchOutcome } from "./records";

function matchupSideTotals({
  episode,
  matchup,
}: {
  readonly episode: RoundEpisodeRow;
  readonly matchup: WatchMatchup;
}): {
  first: number;
  second: number;
} | null {
  const sideByPolicy = new Map<string, "first" | "second">();
  const policies = episode.participants.filter(
    (participant) => participant.kind === "policy",
  );
  const players = policies.filter(
    (participant) => !participant.is_filler && !participant.is_seed,
  );

  for (const participant of players) {
    if (participant.player_id === matchup.first.player_id) {
      sideByPolicy.set(participant.policy_version_id, "first");
    }

    if (participant.player_id === matchup.second.player_id) {
      sideByPolicy.set(participant.policy_version_id, "second");
    }
  }

  if (episode.scores.length === 0) return null;

  const totals = { first: 0, second: 0 };

  for (const score of episode.scores) {
    const side = sideByPolicy.get(score.policy_version_id);

    if (!side) return null;

    totals[side] += score.score;
  }

  return totals;
}

export function episodeOutcome({
  episode,
  matchup,
}: {
  readonly episode: RoundEpisodeRow;
  readonly matchup: WatchMatchup;
}): WatchOutcome {
  const totals = matchupSideTotals({
    episode,
    matchup,
  });

  if (!totals || totals.first === totals.second) return null;

  return totals.first > totals.second ? "first" : "second";
}
